
import { defineComponent, ref } from 'vue';

import Loading from '@/components/Loading.vue';
import Background from '@/components/Background.vue';
import Toggle from '@/components/Toggle.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
    name: 'App',

    components: { Loading, Background, Toggle, Footer },

    setup() {
        const loading = ref(true);

        window.addEventListener('load', () => {
            const body = document.querySelector('body');

            loading.value = false;

            if (body) body.style.overflow = 'visible';
        });

        return { loading };
    },
});
